import { COUNTRY_CODE, SITE_ID } from "../config/config.js";
import { qs } from "../utils/dom.js";
import { fetchJson } from "../utils/api.js";

const GEO_TEXT_BASE_URL = "https://national-lottery-casino.com/api/website/get-geo-text";

export async function renderAfterSupport() {
  const mount = qs("#after-support");
  if (!mount || !SITE_ID || !COUNTRY_CODE) {
    return;
  }

  if (mount.dataset.prerendered === "true") {
    return;
  }

  const url = `${GEO_TEXT_BASE_URL}/${encodeURIComponent(SITE_ID)}/${encodeURIComponent(COUNTRY_CODE)}`;

  const payload = await fetchJson(url);

  const content = payload?.content;
  if (typeof content !== "string" || !content.trim()) {
    throw new Error("[after-support] empty geo text content in API response");
  }

  const template = document.createElement("template");
  template.innerHTML = content.trim();

  const section = template.content.querySelector("#after-support");
  if (!section) {
    throw new Error("[after-support] response does not contain #after-support section");
  }

  section.dataset.prerendered = "true";
  mount.replaceWith(section);
}


